module.exports = __webpack_public_path__ + "static/media/flecha-perfil.06c5c020.svg";